import { Directive } from '@angular/core';

@Directive({
  selector: '[scheduleCardTime]',
  exportAs: 'scheduleCardTime',
})
export class ScheduleCardTimeDirective {}
